import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "./ui/button";

const KEY = "kreuse_cookies_v1";

export default function CookieBanner() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ choice: "accepted", at: new Date().toISOString() }));
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }
    setVisible(false);
  };
  const refuse = () => {
    localStorage.setItem(KEY, JSON.stringify({ choice: "refused", at: new Date().toISOString() }));
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "denied",
        analytics_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
      });
    }
    setVisible(false);
  };

  if (!visible || pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-20 md:bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:bottom-24 sm:max-w-md z-[60] animate-fade-up"
    >
      <div className="bg-white rounded-3xl shadow-2xl border border-[#E5EBE5] p-5">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-2xl bg-[#E8F5E9] flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-[#1B5E20]" />
          </div>
          <div className="flex-1">
            <h3 className="font-['Outfit'] font-semibold text-[#1A2E1C] text-sm mb-1">
              Respect de votre vie privée
            </h3>
            <p className="text-xs text-[#5C705E] leading-relaxed">
              Nous utilisons des cookies techniques nécessaires + Google
              Analytics (anonymisé) uniquement si vous acceptez.{" "}
              <a
                href="/politique-confidentialite"
                className="underline text-[#1B5E20] hover:text-[#164d1a]"
              >
                En savoir plus
              </a>
            </p>
          </div>
          <button
            onClick={refuse}
            data-testid="cookie-close"
            className="p-1 rounded-full hover:bg-[#F1F8F2]"
            aria-label="Fermer"
          >
            <X className="w-4 h-4 text-[#5C705E]" />
          </button>
        </div>
        <div className="flex gap-2">
          <Button
            onClick={refuse}
            data-testid="cookie-refuse"
            variant="outline"
            size="sm"
            className="flex-1 border-[#E5EBE5] text-[#1A2E1C] rounded-full"
          >
            Refuser
          </Button>
          <Button
            onClick={accept}
            data-testid="cookie-accept"
            size="sm"
            className="flex-1 bg-[#1B5E20] hover:bg-[#164d1a] text-white rounded-full"
          >
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
}
